// src/sections/PokeBowls/PokeBowls.js
import React from 'react';
import styles from './PokeBowls.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as solidHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as regularHeart } from '@fortawesome/free-regular-svg-icons';

const pokeBowlsData = [
  {
    id: "poke-menu",
    name: "MENU POKE BOWL",
    description: "1 Poke au choix* + 1 Dessert + 1 Boisson. (*Poke au choix parmi : Saumon, Thon, Mix, Poulet, Veggie. Hors Spéciaux)",
    price: "17.00€",
    image: "/images/poke/poulet.png" // Assurez-vous que cette image existe ou utilisez un placeholder
  },
  {
    id: "poke-salmon",
    name: "SAUMON",
    description: "Saumon, riz sushi vinaigré, avocat, radis, mangue, concombre, choux rouge, édamamé, oignon frit, sésame.",
    price: "12.50€",
    image: "/images/poke/saumon.png"
  },
  {
    id: "poke-ton",
    name: "THON",
    description: "Thon, riz sushi vinaigré, avocat, carotte, édamamé, wakamé, concombre, radis, mangue, oignon frit, sésame.",
    price: "12.50€",
    image: "/images/poke/thon.png"
  },
  {
    id: "poke-mix",
    name: "MIX",
    description: "Saumon, Thon, riz sushi vinaigré, avocat, mangue, radis, concombre, choux rouge, édamamé, soja frais, oignon frit, sésame.",
    price: "12.50€",
    image: "/images/poke/mix.png"
  },
  {
    id: "poke-poulet",
    name: "POULET",
    description: "Brochettes de poulet teriyaki, riz sushi vinaigré, tomate cerise, édamamé, carotte, concombre, choux rouge, soja frais, oignon frit, sésame.",
    price: "12.50€",
    image: "/images/poke/poulet.png"
  },
  {
    id: "poke-veggie",
    name: "VEGGIE",
    description: "Algues Wakamé, riz sushi vinaigré, avocat, radis, édamamé, carotte, choux rouge, mangue, tomate cerise, soja frais, oignon frit, sésame.",
    price: "12.50€",
    image: "/images/poke/veggie.png"
  },
  {
    id: "poke-burrata",
    name: "BURRATA (SPÉCIAL)",
    description: "Burrata, riz sushi vinaigré, avocat, radis, édamamé, concombre, soja frais, sésame.",
    price: "13.00€",
    image: "/images/poke/burrata.png"
  },
  {
    id: "poke-salmon-burrata",
    name: "SAUMON - BURRATA (SPÉCIAL)",
    description: "Saumon - Burrata, riz sushi vinaigré, avocat, radis, édamamé, mangue, carotte, oignon frit, sésame.",
    price: "17.00€",
    image: "/images/poke/saumonburrata.png"
  }
];

const PokeBowls = ({ id, favorites, addFavorite, removeFavorite }) => {
  const isFavorite = (item) => {
    return favorites.some(favItem => favItem.id === item.id);
  };

  const handleFavoriteClick = (item) => {
    if (isFavorite(item)) {
      removeFavorite(item.id);
    } else {
      addFavorite(item);
    }
  };

  return (
    <section id={id} className={styles.pokeBowls}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>NOS POKE BOWLS</h2>
        <p className={styles.sauceInfo}>
          1 SAUCE AU CHOIX : SOJA SALÉE, SOJA SUCRÉE, MANGUE, AIGRE DOUCE
          <span className={styles.supplement}>SUPPLÉMENT SAUCE: 0.50€</span>
        </p>

        <div className={styles.grid}>
          {pokeBowlsData.map((item) => (
            <div key={item.id} className={styles.itemCard}>
              <div className={styles.itemImage}>
                <img src={item.image} alt={item.name} /> {/* Utilisation directe de item.image */}
              </div>
              <div className={styles.itemDetails}>
                <h3 className={styles.itemName}>{item.name}</h3>
                <p className={styles.itemDescription}>{item.description}</p>
                <div className={styles.itemFooter}>
                  <span className={styles.itemPrice}>{item.price}</span>
                  <button
                    className={`${styles.favoriteButton} ${isFavorite(item) ? styles.isFavorite : ''}`}
                    onClick={() => handleFavoriteClick(item)}
                    aria-label={isFavorite(item) ? `Retirer ${item.name} des favoris` : `Ajouter ${item.name} aux favoris`}
                  >
                    <span className={styles.favoriteButtonText}>
                      {isFavorite(item) ? "Retirer des favoris" : "Ajouter aux favoris"}
                    </span>
                    <FontAwesomeIcon icon={isFavorite(item) ? solidHeart : regularHeart} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PokeBowls;